"use client";

import { useLanguage } from "../i18n/LanguageProvider";

import { useCallback, useEffect, useRef, useState } from "react";
import Image from "next/image";

/* ============================================================
   TESTIMONIAL CAROUSEL

   >>>>>> BACA DUA PERINGATAN INI SEBELUM MEMAKAI KOMPONEN. <<<<<<

   ------------------------------------------------------------
   PERINGATAN 1 - ISI DI BAWAH SENGAJA KOSONG, DAN ITU DISENGAJA

   Anda mengirim tangkapan layar halaman testimoni RS Pondok Indah dan
   meminta isinya "diambil" lalu nama rumah sakitnya diganti jadi RS
   Jakarta Medical Center. Itu TIDAK saya kerjakan, dan saya sarankan
   Anda juga tidak mengerjakannya.

   Yang ada di tangkapan layar itu bukan teks contoh. Itu kisah pasien
   sungguhan - Purwanto, Fajar, Triyanawanti, Ayudhiarini, Apriyola,
   Fifi Cendrawati, Wenly Sarwono, Dini Ayu Augustini - lengkap dengan
   foto wajah mereka, dan menyebut dokter sungguhan (dr. Rubiana,
   dr. Sari, dr. Hinky, dr. Rochsismandoko, dr. Eric, dr. Calvin) yang
   praktik di RS Pondok Indah, bukan di RS JMC.

   Menyalinnya dan menukar nama rumah sakitnya berarti RS JMC
   menerbitkan pengakuan pasien yang tidak pernah berobat di RS JMC,
   tentang tindakan medis yang tidak pernah dilakukan di RS JMC, oleh
   dokter yang tidak bekerja di RS JMC. Itu bukan "mengambil desain" -
   itu keterangan palsu, memakai foto orang tanpa izin, sekaligus
   menyalin konten milik rumah sakit lain.

   Kalau ketahuan - dan halaman sumbernya terbuka untuk umum, jadi
   siapa pun bisa membandingkan - yang rusak bukan cuma halaman ini.

   ------------------------------------------------------------
   PERINGATAN 2 - TESTIMONI PASIEN KEMUNGKINAN BESAR DILARANG

   Ini sudah pernah dibahas di dalam proyek Anda sendiri. Buka
   GoogleRating.jsx: seluruh komponen itu dibangun sebagai penilaian
   AGREGAT, dan alasannya ditulis di komentar paling atas - Permenkes
   No. 1787/MENKES/PER/XII/2010 pasal 5 melarang iklan dan publikasi
   pelayanan kesehatan memuat testimoni.

   Artinya komponen yang Anda minta sekarang adalah persis hal yang
   sengaja dihindari beberapa file yang lalu.

   Saya tidak menyimpulkan bahwa Anda pasti melanggar - lanskapnya
   sempat berubah dengan UU Kesehatan 17/2023, dan penerapannya di
   lapangan berbeda-beda. Tapi keputusan ini di atas keputusan desain,
   dan bukan keputusan yang pantas diambil dari tangkapan layar
   kompetitor. TANYAKAN KE BAGIAN LEGAL RS ATAU DINKES SETEMPAT
   sebelum komponen ini ditayangkan.

   Kalau jawabannya tidak boleh: GoogleRating.jsx yang sudah ada
   memberi efek kepercayaan yang serupa tanpa risiko itu.

   ------------------------------------------------------------
   KALAU LEGAL SUDAH MENGIZINKAN, INI YANG HARUS ANDA SIAPKAN

   Untuk TIAP pasien yang ditampilkan:
     1. Izin tertulis untuk memuat kisah DAN fotonya di situs publik.
        Rekam medis dan identitas pasien dilindungi; izin lisan tidak
        cukup kalau nanti ada sengketa.
     2. Kalimatnya kata-kata pasien sendiri, bukan tulisan tim marketing.
     3. Nama dokter sebaiknya JANGAN dicantumkan. Di tangkapan layar
        sumber, nama dokter ikut disebut - itu menggeser testimoni dari
        "pengalaman pasien" jadi "iklan dokter tertentu", dan menaikkan
        risiko regulasinya.
     4. Foto dengan izin yang sama. Kalau pasien tidak mau wajahnya
        tampil, kosongkan `foto` - komponen ini otomatis menggantinya
        dengan lingkaran berinisial.

   BAGAIMANA KOMPONEN INI BERPERILAKU SEKARANG

   Ada satu sakelar, DATA_SUDAH_ASLI, di bawah. Selama masih false:
     - di localhost  : TAMPIL, dengan pita kuning di atasnya. Anda bisa
                       melihat dan menata tampilannya sepuasnya.
     - di production : TIDAK DIRENDER SAMA SEKALI.

   Bukan karena saya menahan-nahan, tapi karena isi contoh yang enak
   dibaca adalah yang paling gampang lolos ke production tanpa ada yang
   sadar. Sakelar itu memaksa keputusannya diambil sekali, sadar, oleh
   orang - bukan terjadi begitu saja karena lupa.

   ============================================================
   CATATAN TEKNIS

   - className ditulis satu baris. String class multi-baris menyelipkan
     karakter akhir baris ke dalam nilai atribut, dan pada project
     ber-CRLF ini memicu hydration error. Sama seperti di Facility.jsx.
   - Logika scroll disalin dari ArticleCarousel.jsx supaya perilaku
     kedua carousel di halaman ini tidak menyimpang: langkah diukur
     dari selisih offsetLeft antar kartu, bukan offsetWidth + angka gap
     yang ditulis manual.
   - Status panah dibaca dari posisi scroll, bukan dari index yang
     disimpan sendiri, supaya tetap benar setelah digeser dengan jari.
   ============================================================ */

/* Judul pindah ke kamus (testimoni.judul).

   ⚠️ ISI TESTIMONINYA SENDIRI TIDAK SAYA PINDAHKAN, dan itu disengaja.
   Kutipan pasien adalah KONTEN, bukan antarmuka: ia butuh versi
   terjemahan sendiri yang disetujui - dan kalau pasiennya berbahasa
   Indonesia, menerjemahkan kata-katanya ke Inggris berarti menaruh
   kalimat yang tidak pernah ia ucapkan sebagai kutipan langsung
   atas namanya.

   Isi TESTIMONI di bawah masih berlabel CONTOH. Sebelum diisi kutipan
   asli, baca dulu peringatan di GoogleRating.jsx: Permenkes
   1787/2010 melarang testimoni pada iklan dan publikasi pelayanan
   kesehatan. Komponen ini dan GoogleRating.jsx saling bertentangan
   soal itu, dan keduanya dipakai bersamaan di page.jsx. Tanyakan ke
   bagian legal RS sebelum menayangkannya. */

/* Nama rumah sakit dipusatkan di sini. Kalau nanti dipakai di dalam
   kutipan, tulis {RS_NAMA} - jangan mengetik namanya berulang kali di
   banyak tempat, karena itu cara paling umum satu tempat ketinggalan
   saat nama resminya berubah. */
const RS_NAMA = "RS Jakarta Medical Center";

/* Foto latar. SENGAJA null secara bawaan.

   Kalau diisi path ke berkas yang belum ada, next/image meminta berkas
   itu dan yang muncul kotak rusak - baru ketahuan setelah halaman
   dibuka. Dengan null, latarnya jatuh ke gradien plum yang selalu
   bekerja.

   Isi kalau fotonya sudah ada, mis. "/images/testimoni-latar.jpg".
   JANGAN memakai foto dari situs rumah sakit lain. */
const FOTO_LATAR = null;

/* ============================================================
   SAKELAR PENGAMAN

   false = isi TESTIMONI di bawah masih contoh.
           -> di localhost  : TAMPIL, dengan pita peringatan.
           -> di production : TIDAK DIRENDER SAMA SEKALI.

   true  = isi TESTIMONI sudah kisah pasien asli yang berizin tertulis.
           Pita hilang, komponen tayang normal di mana pun.

   JANGAN menyetel true hanya supaya kelihatan di production. Baca dua
   peringatan di kepala berkas ini dulu.
   ============================================================ */
const DATA_SUDAH_ASLI = false;

/* ============================================================
   ISI TESTIMONI

   Bentuk tiap entri:
     {
       kutipan: "kata-kata pasien sendiri",
       nama:    "Nama Pasien",
       peran:   "Pasien Persalinan",   // layanan/kondisi, bukan diagnosis rinci
       foto:    "/images/testimoni/nama.jpg",   // atau null
     }

   Enam entri di bawah adalah DUMMY. Nama, kisah, dan layanannya
   karangan - tidak ada pasien bernama begitu, dan tidak ada yang
   pernah mengatakan kalimat-kalimat itu.

   Bentuknya sengaja dibuat menyerupai testimoni sungguhan supaya
   tampilannya bisa dinilai dengan benar. Konsekuensinya: satu-satunya
   yang membedakan dummy ini dari isi asli adalah awalan "CONTOH -" di
   tiap kutipan. JANGAN menghapus awalan itu sampai kutipan aslinya
   benar-benar masuk. Kalau awalannya hilang tapi isinya masih karangan,
   tidak ada lagi yang menahan halaman ini tayang berisi pasien fiktif.

   Panjangnya sengaja berbeda-beda supaya Anda bisa melihat apakah
   tinggi kartunya tetap seragam.

   YANG SENGAJA TIDAK ADA di dummy ini, dan sebaiknya juga tidak ada
   di isi aslinya:
     - nama dokter
     - diagnosis rinci, angka, dosis, atau lama kesembuhan
     - janji hasil ("pasti sembuh", "paling cepat", "terbaik")
   Ketiganya menggeser testimoni jadi iklan layanan medis, dan itu
   bagian yang paling ketat diatur.
   ============================================================ */
/* Kutipan dan peran pindah ke kamus (kunci testimoni.k1..k6 dan
   testimoni.p1..p6). `nama` TETAP di sini: nama orang tidak
   diterjemahkan, dan begitu diganti data asli ia akan datang dari
   sumber yang sama dengan izin tertulisnya.

   Kalau nanti jumlah testimoni berubah, tambahkan pasangan kunci baru
   di dictionary.js dengan pola yang sama. */
const TESTIMONI = [
  { kutipanKey: "testimoni.k1", nama: "Rahmat Nugroho", peranKey: "testimoni.p1", foto: null },
  { kutipanKey: "testimoni.k2", nama: "Siti Lestari", peranKey: "testimoni.p2", foto: null },
  { kutipanKey: "testimoni.k3", nama: "Andi Prasetyo", peranKey: "testimoni.p3", foto: null },
  { kutipanKey: "testimoni.k4", nama: "Dewi Anggraini", peranKey: "testimoni.p4", foto: null },
  { kutipanKey: "testimoni.k5", nama: "Maya Kusuma", peranKey: "testimoni.p5", foto: null },
  { kutipanKey: "testimoni.k6", nama: "Bambang Setiawan", peranKey: "testimoni.p6", foto: null },
];


export default function TestimonialCarousel() {
  const { t } = useLanguage();

  const trackRef = useRef(null);
  const cardRefs = useRef([]);

  const [nav, setNav] = useState({ atStart: true, atEnd: false });

  /* Status dibaca dari posisi scroll, bukan index yang disimpan sendiri.
     Scroll bisa dipicu jari, roda mouse, atau tombol - kalau statusnya
     hanya diubah tombol, panah akan salah menonaktifkan diri setelah
     pengguna menggeser dengan jari. */
  const syncEdges = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;

    const max = track.scrollWidth - track.clientWidth;

    /* Toleransi 4px. Browser sering berhenti di 0,5px dari ujung karena
       pembulatan pecahan piksel; tanpa toleransi, panah tidak pernah
       menonaktifkan diri di ujung kanan. */
    setNav({
      atStart: track.scrollLeft <= 4,
      atEnd: max <= 0 || track.scrollLeft >= max - 4,
    });
  }, []);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    syncEdges();
    track.addEventListener("scroll", syncEdges, { passive: true });
    window.addEventListener("resize", syncEdges);
    return () => {
      track.removeEventListener("scroll", syncEdges);
      window.removeEventListener("resize", syncEdges);
    };
  }, [syncEdges]);

  /* Langkah diukur dari selisih offsetLeft antara kartu pertama dan
     kedua. Kalau dihitung offsetWidth + angka gap yang ditulis manual,
     tiap tekan akan meleset di breakpoint yang gap-nya berbeda, dan
     setelah beberapa kali tekan kartunya berhenti tidak rata lagi. */
  const scrollByCard = (arah) => {
    const track = trackRef.current;
    const cards = cardRefs.current.filter(Boolean);
    if (!track || cards.length === 0) return;

    const step =
      cards.length > 1
        ? cards[1].offsetLeft - cards[0].offsetLeft
        : cards[0].offsetWidth;

    track.scrollBy({ left: arah * step, behavior: "smooth" });
  };

  const onKeyDown = (e) => {
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      scrollByCard(-1);
    }
    if (e.key === "ArrowRight") {
      e.preventDefault();
      scrollByCard(1);
    }
  };

  /* Kosong = tidak ada yang perlu digambar. */
  if (TESTIMONI.length === 0) return null;

  /* PENJAGA PRODUCTION.

     process.env.NODE_ENV diganti nilai literalnya saat build, jadi di
     bundel production baris ini jadi `if (false && ...)` dan seluruh
     komponen ikut terbuang - datanya pun tidak terkirim ke browser.

     Nilainya sama di server dan klien, jadi tidak memicu hydration
     mismatch seperti pengecekan yang bergantung window atau tanggal. */
  const contoh = !DATA_SUDAH_ASLI;
  if (contoh && process.env.NODE_ENV === "production") return null;

  return (
    <section className="relative isolate overflow-hidden py-14 sm:py-16 md:py-20 lg:py-24">

      {/* ---------- LATAR ----------
         Gradien plum selalu digambar sebagai dasar. Foto ditumpuk di
         atasnya HANYA kalau FOTO_LATAR diisi, jadi komponen ini tetap
         tampil benar sebelum fotonya ada. */}
      <div aria-hidden="true" className="absolute inset-0 -z-20 bg-gradient-to-br from-[var(--c-panel)] via-[var(--c-panel-deep)] to-[var(--c-brand-strong)]" />

      {FOTO_LATAR && (
        <Image src={FOTO_LATAR} alt="" fill sizes="100vw" className="-z-20 object-cover object-center" />
      )}

      {/* Lapisan gelap. Pekat sekali (85%) karena foto latar tidak bisa
         diprediksi - foto terang membuat teks putih di atasnya hilang,
         dan itu tidak akan ketahuan sampai fotonya diganti orang lain.
         Warnanya plum #12161a, bukan hitam: lapisan hitam di atas
         halaman berwarna terbaca keabu-abuan. */}
      <div aria-hidden="true" className={`absolute inset-0 -z-10 ${FOTO_LATAR ? "bg-[var(--c-panel-deep)]/85" : "bg-[var(--c-panel-deep)]/20"}`} />

      {/* Tanda kutip hias di pojok kiri atas, seperti referensi.
         aria-hidden karena murni ornamen. */}
      <span aria-hidden="true" className="pointer-events-none absolute -top-4 left-2 select-none font-serif text-[140px] leading-none text-white/10 sm:left-6 sm:text-[190px] lg:left-10 lg:text-[240px]">&rdquo;</span>

      <div className="relative mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-10">

        {/* ---------- PITA PERINGATAN (hanya saat DATA_SUDAH_ASLI false) ----------
           Sengaja mencolok. Pita yang sopan akan diabaikan, dan yang
           diabaikan di sini adalah kisah pasien palsu di situs rumah
           sakit berizin. */}

        {/* ---------- JUDUL + PANAH ----------
           flex-wrap, bukan satu baris kaku. Di layar sempit judulnya
           dua baris dan panah turun ke bawahnya sendiri, alih-alih
           saling menghimpit. */}
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4 sm:mb-10 md:mb-12">
          <h2 className="text-balance text-2xl font-bold leading-[1.15] tracking-tight text-white sm:text-3xl md:text-4xl">
            {t("testimoni.judul")}
          </h2>

          {/* Panah TETAP TERLIHAT saat nonaktif, hanya diredupkan.
             Berbeda dari panah melayang di ArticleCarousel yang
             menghilang: di sini keduanya duduk dalam satu baris
             bersama judul, dan tombol yang hilang membuat baris itu
             berubah lebar setiap kali sampai di ujung. */}
          <div className="flex shrink-0 items-center gap-3">
            <TombolPanah arah="kiri" onClick={() => scrollByCard(-1)} disabled={nav.atStart} t={t} />
            <TombolPanah arah="kanan" onClick={() => scrollByCard(1)} disabled={nav.atEnd} t={t} />
          </div>
        </div>

        {/* ---------- TRACK ----------
           items-stretch supaya semua slide setinggi slide tertinggi;
           kartunya lalu flex-1, jadi tinggi kartu ikut seragam dan
           baris foto+nama di bawahnya rata satu garis meski panjang
           kutipannya berbeda-beda. */}
        <div ref={trackRef} tabIndex={0} onKeyDown={onKeyDown} role="group" aria-label={t("testimoni.trackAria")} className="flex snap-x snap-mandatory items-stretch gap-4 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white [&::-webkit-scrollbar]:hidden sm:gap-6 md:gap-8">
          {TESTIMONI.map((item, i) => (
            <div key={`${item.nama}-${i}`} ref={(el) => (cardRefs.current[i] = el)} className="flex w-[85%] shrink-0 snap-start flex-col sm:w-[58%] lg:w-[31%]">
              <KartuTestimoni item={item} t={t} />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

/* ============================================================
   KARTU

   Ekor segitiga di bawah kartu dibuat dari kotak putih yang diputar
   45 derajat, BUKAN dari trik border transparan. Kotak yang diputar
   ikut mewarisi warna latar kartu, jadi kalau nanti warna kartunya
   diubah, ekornya ikut berubah tanpa perlu diingat.
   ============================================================ */

function KartuTestimoni({ item, t }) {
  return (
    <>
      <blockquote className="relative flex flex-1 items-center rounded-2xl bg-[var(--c-surface)] px-5 py-6 text-center shadow-[0_10px_30px_-12px_rgba(47,4,37,0.5)] sm:rounded-[20px] sm:px-7 sm:py-8">
        <p className="text-[13px] leading-relaxed text-slate-700 sm:text-sm md:text-[15px]">
          {t(item.kutipanKey)}
        </p>

        <span aria-hidden="true" className="absolute -bottom-2 left-1/2 h-4 w-4 -translate-x-1/2 rotate-45 rounded-[2px] bg-[var(--c-surface)]" />
      </blockquote>

      {/* mt-auto tidak dipakai di sini: kartunya sudah flex-1, jadi
         baris ini otomatis terdorong ke dasar slide. */}
      <figcaption className="mt-7 flex items-center justify-center gap-3 sm:mt-8">
        <Avatar item={item} />

        <div className="min-w-0">
          <p className="truncate text-sm font-bold text-white sm:text-base">{item.nama}</p>
          {item.peranKey && (
            <p className="truncate text-xs text-white/70 sm:text-sm">{t(item.peranKey)}</p>
          )}
        </div>
      </figcaption>
    </>
  );
}

/* Lingkaran berinisial dipakai kalau `foto` kosong. Ini bukan sekadar
   penampung: sebagian pasien memberi izin untuk kisahnya tapi tidak
   untuk wajahnya, dan itu harus bisa dilayani tanpa mengosongkan
   seluruh entri. */
function Avatar({ item }) {
  if (!item.foto) {
    const inisial = (item.nama || "?").trim().charAt(0).toUpperCase();
    return (
      <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--c-brand)] text-sm font-bold text-white ring-2 ring-white/40 sm:h-12 sm:w-12 sm:text-base">
        {inisial}
      </span>
    );
  }

  return (
    <span className="relative h-11 w-11 shrink-0 overflow-hidden rounded-full ring-2 ring-white/40 sm:h-12 sm:w-12">
      <Image src={item.foto} alt="" fill sizes="48px" className="object-cover object-center" />
    </span>
  );
}

/* ============================================================
   TOMBOL PANAH

   44x44px di ponsel - ambang minimum target sentuh yang lazim dipakai.
   Ukuran itu yang menentukan h-11 w-11, bukan selera.
   ============================================================ */

function TombolPanah({ arah, onClick, disabled, t }) {
  const kiri = arah === "kiri";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={kiri ? t("testimoni.sebelumnya") : t("testimoni.berikutnya")}
      className="flex h-11 w-11 items-center justify-center rounded-full bg-[var(--c-brand)] text-white ring-1 ring-white/25 transition-colors duration-200 hover:bg-[var(--c-brand-mid)] disabled:pointer-events-none disabled:opacity-40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white motion-reduce:transition-none sm:h-12 sm:w-12"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-5 w-5">
        <path d={kiri ? "M19 12H5m0 0 6-6m-6 6 6 6" : "M5 12h14m0 0-6-6m6 6-6 6"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
